import React from 'react';
import ProjectDetail from './ProjectDetail';
import { projectMeta } from './data';
import ProgressiveImg from '../components/ProgressiveImg';
import { toCdn } from '../utils/cdn';
import Figure from '../components/Figure';

export default function Marketplace() {
  const meta = projectMeta.marketplace;
  return (
    <ProjectDetail title={meta.title} date={meta.date} role={meta.role} url={meta.url}>
      {/* Custom per-project content goes here */}

      <p>From 2017 to 2022, I led design initiatives for Facebook Marketplace, improving core buyer and seller experiences across the main feed, navigation, product detail pages, messaging and end-to-end flows. Over one billion people use the Marketplace Feed monthly, which was one of my main responsibilities during my time on the team.</p>

      <div className="media-gallery">

        <Figure caption="Marketplace Feed">
          <ProgressiveImg
            src={toCdn('/images/projects/marketplace/marketplace_1.webp')}
            alt="Marketplace Feed"
            className="gallery-item"
          />
        </Figure>

      </div>

      <h3>Marketplace Design System</h3>
      <p>During my time on Marketplace, I established and led a design infrastructure team. The team was made up of a small group of designers, UI engineers, and content strategists. Our goals were to centralize design resources and establish new processes for maintaining and evolving the Marketplace design system.</p>

      <p>The Marketplace system was an extension of Facebook's core design system, however, prior to this effort there was no dedicated team responsible for maintaning it's health which led to significant design and technical debt.</p>

      <p>In our first year we introduced a new shared component library, design system documentation with guidelines for usage, established critiques and governance processes, and updated or deprecated outdated components. This work led to significant metric improvements and was a major step towards building a sustainable design system for Marketplace. It alsogave other teams the tools they needed to build consistent and high-quality products.</p>

      <div className="media-gallery">
        <Figure caption="Search, Filters, Detail Page">
          <ProgressiveImg
            src={toCdn('/images/projects/marketplace/marketplace_2.webp')}
            alt="Search, Filters, Detail Page"
            className="gallery-item"
          />
        </Figure>
        <Figure caption="Component Library">
          <ProgressiveImg
            src={toCdn('/images/projects/marketplace/marketplace_3.webp')}
            alt="Component Library"
            className="gallery-item"
          />
        </Figure>

      </div>

    </ProjectDetail>
  );
}
